export const servicesData = [
  {
    id: 'meditation-between-worlds',
    title: 'Meditation Between the Worlds',
    summary:
      'Experience stillness, clarity, and inner connection in live or online sessions.',
    price: 'From €15 / session',
    priceDetail: 'One-time hourly fee €15 • Monthly fee €50 (paid in advance)',
    image:
      'https://images.unsplash.com/photo-1508672019048-805c876b67e2?auto=format&fit=crop&q=80',
    link: '/services/meditation-between-worlds',
  },
  {
    id: 'sound-infused-renewal',
    title: 'Sound – Infused Renewal Transformation',
    summary:
      'Release stress and restore your natural flow with gentle tuning fork therapy.',
    price: '€100 / session',
    priceDetail:
      'Includes an initial consultation, the therapy session, and a final check-in with feedback.',
    image:
      'https://cdn.magicpatterns.com/uploads/cdsiiZmq446oBjGYDRe6Ki/tuning-fork-healing-trpws.jpg',
    link: '/services/sound-infused-renewal',
  },
  {
    id: 'sopotje',
    title: 'Sopotje – Guidance and Presence Support Sessions',
    summary:
      'Compassionate space for reflection, clarity, and personal growth.',
    price: '€60 / hour',
    priceDetail: 'Hourly fee €60',
    image:
      'https://images.unsplash.com/photo-1476480862126-209bfaa8edc8?auto=format&fit=crop&q=80',
    link: '/services/sopotje',
  },
]
